import * as types from './constants';
import api, { getMediaRelateInBookPage } from '../_api'

const getEBooks = ({ commit }, params = {}) => {
    api.getEBooks(params)
        .then((response) => {
            commit(types.GET_EBOOKS, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};
const getEBooksDetail = ({ commit }, id) => {
    //let id =49;
    //  console.log(params)
    api.getEBooksDetail(id)
        .then((response) => {
            commit(types.GET_EBOOKS_DETAIL, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};
const actionGetTraningId = ({ commit }, id) => {
    //let id =49;
    //  console.log(params)
    api.getTraningId(id)
        .then((response) => {
            commit(types.GET_TRAINING_ID, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};

const setBookDetail = ({ commit }, data) => {
    commit(types.GET_EBOOKS_DETAIL, data);
}

const getEBooksType = ({ commit }, params = {}) => {
    //let id =49;
    api.getEBooksType(params)
        .then((response) => {
            commit(types.GET_EBOOKS_TYPE, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};
// const getEBooksGroup = ({ commit },  params = {})=>{
//   //let id =49;
//   api.getEBooksGroup(params)
//     .then((response) => {
//       commit(types.GET_EBOOKS_GROUP, response.data);
//     })
//     .catch((error) => {
//       // eslint-disable-next-line
//       console.error(error);
//     });
// };
const getEBooksClass = ({ commit }, params = {}) => {
    //let id =49;
    //  console.log(params)
    api.getEBooksClass(params)
        .then((response) => {
            commit(types.GET_EBOOKS_CLASS, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};

const getAllClasses = ({ commit }, id) => {
    //let id =49;
    //  console.log(params)
    api.getAllClasses(id)
        .then((response) => {
            commit(types.GET_ALL_CLASSES, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};

const getEBooksFilter = ({ commit }, data) => {
    return commit(types.GET_EBOOKS_FILTER, data);
}



const getBookSearch = ({ commit }, keyword) => {
    api.getPageSearch(keyword)
        .then((response) => {
            commit(types.GET_PAGE_SEARCH, response.data);
        })
        .catch((error) => {
            console.error(error);
        });
};

const getExerciseDetail = ({ commit }, id) => {
    api.getExerciseDetail(id)
        .then((response) => {
            commit(types.GET_EXERCISE_DETAIL, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};

const getExerciseFilter = ({ commit }, data) => {
    return commit(types.GET_EXERCISE_FILTER, data);
}

const getQuestionExercise = ({ commit }, id) => {
    api.getQuestionByLesson(id)
        .then((response) => {
            commit(types.GET_QUESTION_EXERCISE_INFO, response.data);
            if (response.data && response.data.exercises) {
                let lengthExercise = response.data.exercises.length;
                let dataExercise = lengthExercise > 0 ? response.data.exercises[lengthExercise - 1].exercises_question : [];
                commit(types.GET_QUESTION_EXERCISE, dataExercise);
            }
        })
        .catch(error => console.error(error));
}

const getFilters = ({ commit }, params = {}) => {
    api.getFilters(params)
        .then((response) => {
            commit(types.GET_FILTERS, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};

const setQuestionActivity = ({ commit }, data) => {
    return commit(types.SET_QUESTION_ACTIVITY, data);
}

const toggleFormMath = ({ commit }, value) => {
    commit(types.OPEN_MATH_FORM, value);
}

const sendValueMathlive = ({ commit }, value) => {
    commit(types.SEND_MATH_VAL, value);
}

const validateQuestion = ({ commit }, data) => {
    commit(types.VALIDATE_QUESTION, data);
}

const checkQuestionCorrect = ({ commit }, data) => {
    commit(types.CHECK_CORRECT_QUESTION, data);
}

const setQuestionValidData = ({ commit }, data) => {
    commit(types.SET_QUESTION_VALID_DATA, data);
}

const acSetEbookQuestionWork = ({ commit }, data) => {
    commit(types.EBOOK_SET_QUESTION_WORKING, data);
}
const acSetMediaBookViewing = ({ commit }, data) => {
    commit(types.EBOOK_SET_MEDIA_VIEWING, data);
}
const acSetLessonBookViewing = ({ commit }, data) => {
    commit(types.EBOOK_SET_LESSON_VIEWING, data);
}


const getBookRelation = ({ commit }, id) => {
    //let id =49;
    //  console.log(params)
    api.getBookRelation(id)
        .then((response) => {
            commit(types.GET_BOOK_RELATION, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};


const getBookFAQ = ({ commit }, id) => {
    //let id =49;
    //  console.log(params)
    api.getBookFAQ(id)
        .then((response) => {
            commit(types.GET_BOOK_FAQ, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};

const getRelateMedia = ({ commit }, params) => {
    return getMediaRelateInBookPage(params).then(res => {
        return (res && res.data && !res.errors) ? res.data : [];
    }).catch(() => { return false; });
}

const acSetDataBookDeActive = ({ commit }, data) => {
    commit(types.SET_DATA_DEACTIVE_BOOK, data)
}

// Reset actived again book detail
const acSetIdBookDeActiveDone = ({ commit }, data) => {
    commit(types.SET_ID_BOOK_DEACTIVE_DONE, data)
}

export default {
    getEBooks,
    getEBooksDetail,
    setBookDetail,
    getEBooksType,
    getEBooksClass,
    getEBooksFilter,
    getAllClasses,
    getBookSearch,
    getFilters,
    //getEbooksGroup,
    getExerciseDetail,
    getQuestionExercise,
    toggleFormMath,
    sendValueMathlive,
    validateQuestion,
    setQuestionActivity,
    checkQuestionCorrect,
    setQuestionValidData,
    getBookRelation,
    getBookFAQ,
    getRelateMedia,
    actionGetTraningId,
    acSetEbookQuestionWork,
    acSetMediaBookViewing,
    acSetLessonBookViewing,
    acSetDataBookDeActive,
    acSetIdBookDeActiveDone
};